import { isValidRut } from './is-valid-rut.handle';

export const validateRecipes = (recipes) => {
  const errors = []; 
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  recipes.forEach((recipe, index) => {
    const n = index + 1; 


const patient = recipe.patient || {};

    if (!patient.first_name?.trim()) {
      errors.push(`Receta ${n}: Falta el Nombre del titular.`);
    }

    if (!patient.last_name?.trim()) {
      errors.push(`Receta ${n}: Falta el Apellido del titular.`);
    }

    const patientRut = patient.rut?.trim();
    if (!patientRut) {
      errors.push(`Receta ${n}: Falta el RUT del titular.`);
    } else {
      if (!isValidRut(patientRut)) {
        errors.push(`Receta ${n}: El RUT del titular "${patientRut}" no es válido.`);
      }
    }




    const prof = recipe.professional || {}; 

    
    if (!prof.first_name?.trim()) {
      errors.push(`Receta ${n}: Falta el Nombre del profesional.`);
    }
    
    if (!prof.last_name?.trim()) {
      errors.push(`Receta ${n}: Falta el Apellido del profesional.`);
    }
    
    const rut = prof.rut?.trim();
    if (!rut) {
      errors.push(`Receta ${n}: Falta el RUT del profesional.`);
    } else {
      if (!isValidRut(rut)) {
        errors.push(`Receta ${n}: El RUT "${rut}" no es válido.`);
      }
    }

    if (!recipe.expiration_date) {
      errors.push(`Receta ${n}: Falta la Fecha de expiración.`);
    }
    
    if (!recipe.renewal_date) {
      errors.push(`Receta ${n}: Falta la Fecha de renovación.`);
    }

    const products = recipe.products || {};
    
    const commercialCount = products.commercial?.length || 0;
    const magistralFinishedCount = products.magistralFinished?.length || 0;
    const magistralToMakeCount = products.magistralToMake?.length || 0;

    const totalProducts = commercialCount + magistralFinishedCount + magistralToMakeCount;

    if (totalProducts === 0) {
      errors.push(`Receta ${n}: Debe tener al menos un producto cargado (Comercial o Magistral).`);
    }

    const email = prof.email;
    if (email && email.trim().length > 0) {
      if (!emailRegex.test(email)) {
        errors.push(`Receta ${n}: El Email "${email}" no es válido.`);
      }
    }
  });

  return errors.length > 0 ? errors : null;
};